import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Form,
  Card,
  Row,
  Col,
  Button,
  Select,
  Table,
  Modal,
  message,
  InputNumber,
  Popconfirm,
  Upload,
} from 'antd';

import PageHeaderLayout from '../../component/page-header-layout/index';
import {
  list,
  fetchAllGroup,
  getStallGroupById,
  marketList,
  saveOrUpdateStallGroup,
} from '../../state/action/stall';
import { deleteStallGroup } from '@/state/request/stall';

import '../booth-management/index.less';
import { isEmptyObject } from '../../utils/reg';
import { API_ADMIN } from '../../utils/urls';
import { generalParamsWithPToStr } from '../../utils/math';
import { getAuthorityUserInfo } from '../../utils/authority';

const FormItem = Form.Item;
const Option = Select.Option;
const { Column } = Table;

@connect(
  (state) => {
    return { stall: state.stall, batch: state.batch };
  },
  {
    list,
    fetchAllGroup,
    getStallGroupById,
    marketList,
    saveOrUpdateStallGroup,
  },
)
@Form.create()
class BoothGroup extends PureComponent {
  componentDidMount() {
    const groupNo = !isEmptyObject(this.props.match) ? this.props.match.params.id : 0;
    this.fetchAllGroup({
      pageNo: 1,
      pageSize: 10,
      groupNo: groupNo,
    });
    this.fetchAllMarkets({});
    this.props.list();
  }

  constructor(props) {
    super(props);
    this.state = {
      selectValue: '',
      visibleModal: false,
      value: 1,
      id: '',
      type: '',
      pageNo: 1,
      pageSize: 10,
    };

    this.handleCancel = this.handleCancel.bind(this);
  }

  async fetchAllGroup(params) {
    await this.props.fetchAllGroup(params);
  }

  // 获取档口列表
  async fetchAllMarkets(params) {
    await this.props.marketList(params);
  }

  // 修改档口配置
  async saveOrUpdate(params) {
    await this.props.saveOrUpdateStallGroup(params);
    this.submit();
  }

  // 分页和查询请求
  handleOnQuery = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields({ force: true }, (err, fieldsValue) => {
      const groupNo = !isEmptyObject(this.props.match) ? this.props.match.params.id : 0;

      let params = {};
      const marketId = fieldsValue.marketId || '';
      const stallName = fieldsValue.stallName || '';
      const systemType = fieldsValue.systemType;
      if (fieldsValue.systemType !== '0') {
        params.systemType = systemType;
      }
      this.fetchAllGroup({
        ...params,
        id: this.state.id,
        groupNo: groupNo,
        marketId: marketId,
        stallName: stallName,
        pageNo: 1,
        pageSize: 10,
      });
      this.setState({ pageNo: 1, pageSize: 10 });
    });
  };

  // 商行选择onchange事件
  onChange = (value) => {
    this.setState({
      selectValue: value,
    });
  };

  // 分页切换
  pageSwitch = (obj) => {
    this.props.form.validateFields({ force: true }, (err, fieldsValue) => {
      const groupNo = !isEmptyObject(this.props.match) ? this.props.match.params.id : 0;
      let params = {};
      const stallName = fieldsValue.stallName || '';
      const systemType = fieldsValue.systemType;
      const marketId = fieldsValue.marketId || '';
      if (fieldsValue.systemType !== '0') {
        params.systemType = systemType;
      }
      if (marketId) {
        params.marketId = marketId;
      }
      this.fetchAllGroup({
        ...params,
        groupNo: groupNo,
        stallName: stallName,
        pageNo: obj.current,
        pageSize: obj.pageSize,
      });
      this.setState({ pageNo: obj.current, pageSize: obj.pageSize });
    });
  };

  // modal关闭事件
  handleCancel(e) {
    this.setState({
      visibleModal: false,
    });
  }

  // 删除档口分组
  async deleteGroup(e, groupNo, stallId) {
    e.preventDefault();
    const resData = await deleteStallGroup({ groupNo, stallId });
    const msg = '移除';
    if (resData.code === 200) {
      message.success(`${msg}成功`);
    } else if (resData.msg) {
      message.error(resData.msg);
    } else {
      message.error(`${msg}失败`);
    }
    this.handleOnQuery();
  }

  // 修改信息的回调
  submit() {
    const {
      stall: { resData },
    } = this.props;
    const msg = '操作';

    if (resData.code === 200) {
      message.success(`${msg}成功`);
    }
    this.handleOnQuery();
  }

  // 表单提交
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields({ force: true }, (err, fieldsValue) => {
      if (err) {
        return;
      }
      const { businessCodes } = fieldsValue;
      const groupNo = !isEmptyObject(this.props.match) ? this.props.match.params.id : 0;
      this.saveOrUpdate({
        groupNo: groupNo,
        businessCodes: businessCodes,
      });

      this.setState({
        visibleModal: false,
      });
    });
  };

  // 新增档口配置
  add() {
    this.setState({
      visibleModal: true,
      type: 'add',
      id: null,
    });
  }
  //返回到档口分组配置
  toBoothAllGroup() {
    this.props.history.push('/booth/boothAllGroup');
  }

  handleReset = () => {
    this.props.form.resetFields();
    const groupNo = !isEmptyObject(this.props.match) ? this.props.match.params.id : 0;
    this.setState({
      selectValue: '',
      pageNo: 1,
      pageSize: 10,
    });
    this.fetchAllGroup({
      id: this.state.id,
      groupNo: groupNo,
      stallName: '',
      pageNo: 1,
      pageSize: 10,
    });
  };

  //上传之前拦截下
  beforeUpload = (file) => {
    const str = file.name.split('.')[1];
    const isRightType = str === 'xls' || str === 'xlsx';
    const limitSize = file.size / 1024 / 1024 < 1;
    if (!isRightType) {
      message.error('仅支持Excel文件!', 3);
    }
    if (!limitSize) {
      message.error('文件大小不超过1M');
    }
    return limitSize;
  };
  //上传之后的改变事件
  handleChangeByUpload = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
    }
    if (info.file.status === 'done') {
      this.setState({ loading: false });
      if (info.file.response.code === 200) {
        message.success(`${info.file.name} 上传成功!`, 5);
        // 刷新页面
        const groupNo = !isEmptyObject(this.props.match) ? this.props.match.params.id : 0;
        this.setState({ pageNo: 1, pageSize: 10 });
        this.fetchAllGroup({
          groupNo: groupNo,
          pageNo: 1,
          pageSize: 10,
        });
      } else if (info.file.response.code === 8009) {
        message.error(info.file.response.msg, 5);
      } else {
        message.error(info.file.response.msg, 5);
      }
    } else if (info.file.status === 'error') {
      if (info.file && info.file.response && info.file.response.msg) {
        message.error(info.file.response.msg, 5);
      } else {
        message.error(`${info.file.name} 上传失败`, 5);
      }
      this.setState({ loading: false });
    }
  };

  render() {
    let {
      stall: { groupInfo, allStallsGroupData = {}, marketData = [], allStallsData = [] },
    } = this.props;

    const { pageList = [], totalSize = 0 } = allStallsGroupData;

    const { getFieldDecorator } = this.props.form;

    let data = {};
    if (groupInfo !== undefined && groupInfo !== null && this.state.type !== 'add') {
      data = groupInfo;
      this.setState({
        id: data.id,
      });
    }
    let { groupNo, type, stallId, marketId } = data;
    if (groupNo === undefined || groupNo === null) {
      groupNo = !isEmptyObject(this.props.match) ? this.props.match.params.id : 0;
    }
    if (type === undefined || type === null) {
      type = '';
    }
    if (stallId === undefined || stallId === null) {
      stallId = '';
    }
    if (marketId === undefined || marketId === null) {
      marketId = '';
    }

    if (marketData !== null && marketData !== undefined && marketData.length) {
      const tmpMarketData = [];
      for (let i = 0; i < marketData.length; i++) {
        tmpMarketData.push(marketData[i]);
      }
      marketData = tmpMarketData;
    } else {
      marketData = [];
    }

    if (allStallsData !== null && allStallsData !== undefined && allStallsData.length) {
      const tmpallStallsData = [];
      for (let i = 0; i < allStallsData.length; i++) {
        tmpallStallsData.push(allStallsData[i]);
      }
      allStallsData = tmpallStallsData;
    } else {
      allStallsData = [];
    }

    let userinfo = getAuthorityUserInfo();
    let hash = !isEmptyObject(userinfo) ? userinfo.access_token : '';
    const uploadContractProps = {
      name: 'file',
      action: `${API_ADMIN}stallGroup/importStall/${groupNo}`,
      headers: {
        authorization: 'authorization-text',
        accessToken: hash,
        appType: 'admin',
      },
      beforeUpload: this.beforeUpload,
      showUploadList: false,
      onChange: this.handleChangeByUpload,
    };

    const layout = { xs: 24, sm: 12, md: 8, lg: 6, xl: 6 };
    const extraContent = (
      <div className={'searchModule'}>
        <Form onSubmit={this.handleOnQuery}>
          <Row gutter={12}>
            <Col {...layout}>
              <FormItem label='市场名称' labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                {getFieldDecorator('marketId', {
                  rules: [{ required: false, message: '请选择市场!' }],
                })(
                  <Select
                    placeholder='请选择市场'
                    style={{ width: '100%' }}
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {marketData.map((item) => (
                      <Option key={item.id}>{item.name}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col {...layout}>
              <FormItem label='商行名称' labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                {getFieldDecorator('stallName', {
                  rules: [{ required: false, message: '请输入商行名称!' }],
                })(<Input placeholder='请输入商行名称' allowClear style={{ width: '100%' }} />)}
              </FormItem>
            </Col>
            <Col {...layout}>
              <FormItem
                label='系统类型'
                name='systemType'
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
              >
                {getFieldDecorator('systemType', {
                  initialValue: '0',
                })(
                  <Select style={{ width: '100%' }} placeholder='请选择系统类型'>
                    <Option key={'0'} value={'0'}>
                      全部
                    </Option>
                    <Option key={'1'} value={'1'}>
                      正式商行
                    </Option>
                    <Option key={'2'} value={'2'}>
                      测试商行
                    </Option>
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Button type='primary' htmlType='submit'>
              查询
            </Button>
            <Button style={{ marginLeft: '12px' }} onClick={this.handleReset}>
              重置
            </Button>
            <Button type='primary' style={{ marginLeft: '12px' }} onClick={this.add.bind(this)}>
              新增
            </Button>
            <Button style={{ marginLeft: '12px' }} onClick={this.toBoothAllGroup.bind(this)}>
              返回档口分组
            </Button>
            <Button
              onClick={() =>
                window.open(
                  `${API_ADMIN}versionRefer/downloadTemplet?${generalParamsWithPToStr(
                    'versionRefer/downloadTemplet',
                    {},
                  )}`,
                )
              }
              style={{ marginLeft: '12px' }}
            >
              模板下载
            </Button>
            <Upload {...uploadContractProps}>
              <Button type='primary' icon='upload' target='_blank' style={{ marginLeft: '12px' }}>
                批量导入
              </Button>
            </Upload>
          </Row>
        </Form>
      </div>
    );

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const pagination = {
      current: this.state.pageNo,
      pageSize: this.state.pageSize,
      total: totalSize,
    };

    return (
      <div className='booth-index'>
        <PageHeaderLayout>
          <div className={'batchLayout'}>
            <Card className={'listCard'} bordered={false} title='' extra={extraContent}>
              <Table
                dataSource={pageList}
                pagination={pagination}
                rowKey='id'
                bordered
                onChange={this.pageSwitch.bind(this)}
              >
                <Column title='分组编号' dataIndex='groupNo' key='groupNo' />
                <Column title='商行业务ID' dataIndex='businessCode' key='businessCode' />
                <Column title='商行名称' dataIndex='stallName' key='stallName' />
                <Column title='市场名称' dataIndex='marketName' key='marketName' />
                <Column
                  title='是否启用'
                  dataIndex='enable'
                  key='enable'
                  render={(_, record) => {
                    const { enable } = record;
                    const txt = enable ? '启用' : '禁用';
                    return <span>{txt}</span>;
                  }}
                />
                <Column
                  title='操作'
                  dataIndex='operating'
                  key='operating'
                  render={(_, record) => {
                    const { groupNo, stallId } = record;
                    return (
                      <div>
                        <Popconfirm
                          title='是否确定移除'
                          onConfirm={(e) => this.deleteGroup(e, groupNo, stallId)}
                          okText='确认'
                          cancelText='取消'
                        >
                          <a href='/'>
                            <span>移除</span>
                          </a>
                        </Popconfirm>
                      </div>
                    );
                  }}
                />
              </Table>
            </Card>
            <Card>
              <Modal
                title={this.state.type === 'add' ? '新增档口分组' : '修改档口分组'}
                visible={this.state.visibleModal}
                footer={null}
                onCancel={this.handleCancel}
                destroyOnClose='true'
                width='600px'
              >
                <div className={'extraContent'} style={{ width: '100%' }}>
                  <Form key={this.state.id || 0} onSubmit={this.handleSubmit}>
                    <FormItem {...formItemLayout} label='分组编号'>
                      {getFieldDecorator('groupNo', {
                        initialValue: groupNo,
                        rules: [
                          {
                            required: true,
                            message: ' 请输入分组编号!',
                          },
                        ],
                      })(
                        <Input
                          style={{ paddingLeft: '0px', width: '100%' }}
                          readOnly
                          placeholder='请输入分组编号'
                        />,
                      )}
                    </FormItem>
                    <FormItem {...formItemLayout} label='商行业务ID'>
                      {getFieldDecorator('businessCodes', {
                        initialValue: marketId,
                        rules: [
                          {
                            required: true,
                            message: '请填入商行业务ID!',
                          },
                        ],
                      })(
                        <Input.TextArea
                          placeholder='请填入商行业务ID,多个以中文顿号(、)分隔'
                          style={{ width: '100%' }}
                          rows={3}
                        />,
                      )}
                    </FormItem>
                    <FormItem>
                      <div style={{ textAlign: 'right' }}>
                        <Button type='primary' htmlType='submit'>
                          保存
                        </Button>
                      </div>
                    </FormItem>
                  </Form>
                </div>
              </Modal>
            </Card>
          </div>
        </PageHeaderLayout>
      </div>
    );
  }
}

export default BoothGroup;
